module.exports = __webpack_public_path__ + "img/9c4cca0.png";